import React, { useCallback } from 'react';
import { AccountSocketData } from 'api/pushes';
import { Export, ExportStatus } from 'api/reports/csat';
import { toastService } from 'components/molecules/toast';
import { useTranslate } from 'hooks/use-translation';
import { logger } from 'services';

interface Props {
  onExportCompleted: () => void;
  isExportInProgress?: boolean;
}

export const useAsyncExport = ({
  onExportCompleted,
  isExportInProgress,
}: Props): { handleExport: (res: AccountSocketData<string>) => void } => {
  const translate = useTranslate();
  const handleExport = useCallback(
    (response: AccountSocketData<string>) => {
      logger.log('async-create ~ socketData', response);
      const data: Export = JSON.parse(response.data);

      if (
        !data ||
        !data.downloadUrl ||
        data.status !== ExportStatus.Completed
      ) {
        toastService({
          title: translate('async.exports.error.title'),
          message: translate('async.exports.error.message'),
        }).error();
        onExportCompleted();

        return;
      }
      const { downloadUrl } = data;

      if (!isExportInProgress) {
        return;
      }
      window.open(downloadUrl, '_blank');
      toastService({
        title: translate('async.exports.success.title'),
        message: (
          <p>
            {translate('async.exports.success.message')}
            <br />
            <a href={downloadUrl} download>
              {translate('download.file')}
            </a>
          </p>
        ),
        duration: 15,
      }).success();
      onExportCompleted();
    },
    [isExportInProgress, onExportCompleted, translate],
  );

  return { handleExport };
};
